<template>
    <div class="TheModeC">
        <div class="Title">
            <div>
                <p>最新资讯</p>
            </div>
            <!-- <span>LATEST INFORMATION</span> -->
        </div>
        <el-row type="flex" class="row-bg" justify="center">
            <el-col :span="24">
                <div
                    class="backg-left"
                    v-for="item in summarizing"
                    :key="item.index"
                >
                    <div class="mongolia"></div>
                    <img class="blue" :src="item.image" />
                    <div class="customer">
                        <p class="ymdd">{{ item.title }}</p>
                        <div class="sides">
                            <a> </a>
                            <a class="short"> </a>
                            <a class="short"> </a>
                            <a class="short"> </a>
                        </div>
                        <p class="highness">{{ item.description }}</p>
                        <el-button @click="jumpPage(item)" class="beautiful btn"
                            >查看详情 <i class="el-icon-caret-right"></i
                        ></el-button>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { selectfarnews } from "@/api/homePage";
export default {
    data() {
        return {
            summarizing: []
        };
    },
    created() {
        this.newsquery();
    },
    methods: {
        //新闻跳转
        jumpPage(item) {
            this.$router.push({
                path: item.demoFlag,
                query: {
                    id: item.menuId,
                    contentid: item.articleId
                }
            });
        },
        newsquery() {
            selectfarnews()
                .then(res => {
                    if (res.status === 2000) {
                        this.summarizing = res.data;
                    }
                })
                .catch(err => {});
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.TheModeC {
    .Title {
        text-align: center;
        margin-top: 80px;
        p {
            display: inline-block;
            margin: 0;
            font-size: 24px;
        }
        span {
            display: inline-block;
            margin-top: 8px;
            font-size: 11px;
            color: #666;
        }
    }
    .el-row {
        margin-top: 60px;
        .el-col {
            position: relative;
            overflow: hidden;
            .backg-left {
                width: 70.5%;
                // height: 500px;
                transform: skew(-30deg);
                position: relative;
                margin-left: -21%;
                margin-bottom: 0;
                // padding: 0 0 0 10%;
                float: left;
                background-color: #000;
                overflow: hidden;
                .mongolia {
                    z-index: 9;
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.7);
                }
                .blue {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    left: 200px;
                    transform: skew(30deg);
                }
                .customer {
                    z-index: 99;
                    position: absolute;
                    top: 100px;
                    left: 50%;
                    // transform: translate(40%, -70%);
                    transform: skew(30deg);
                    color: #fff;
                    p {
                        width: 320px;
                        font-size: 14px;
                        margin-top: 14px;
                        line-height: 26px;
                    }
                    .highness {
                        width: 260px;
                        // overflow: hidden;
                        // text-overflow: ellipsis;
                        // white-space: nowrap;
                    }
                    .ymdd {
                        width: 360px;
                        font-size: 24px;
                        line-height: 36px;
                        // overflow: hidden;
                        // text-overflow: ellipsis;
                        // white-space: nowrap;
                    }
                    .btn {
                        position: relative;
                        font-size: 14px;
                        border-radius: 6px;
                        width: 160px;
                        height: 40px;
                        margin-top: 32px;
                        color: #fabe00;
                        border-color: #fabe00;
                        background: -webkit-linear-gradient(
                                left,
                                #fabe00,
                                #fabe00
                            )
                            no-repeat;
                        background: linear-gradient(to right, #fabe00, #fabe00)
                            no-repeat;
                        background-size: 0% 100%;
                    }
                    .btn:hover {
                        background-size: 100% 100%;
                        color: #27323a;
                    }
                }
            }
            .backg-left:nth-child(2) {
                width: 71%;
                // height: 500px;
                transform: skew(-30deg);
                position: relative;
                margin-right: -21%;
                // padding: 0 0 0 5%;
                float: right;
                background-color: red;
                display: flex;
                overflow: hidden;
                .mongolia {
                    z-index: 9;
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(250, 190, 0, 0.7);
                }
                .blue {
                    position: relative;
                    left: -250px;
                    width: 100%;
                    height: 100%;
                    transform: skew(30deg);
                }
                .customer {
                    z-index: 99;
                    position: absolute;
                    top: 100px;
                    left: 160px;
                    transform: skew(30deg);
                    color: #fff;
                    p {
                        width: 260px;
                        font-size: 14px;
                        margin-top: 14px;
                        color: #fff;
                        line-height: 26px;
                    }
                    .highness {
                        width: 260px;
                        // overflow: hidden;
                        // text-overflow: ellipsis;
                        // white-space: nowrap;
                    }
                    .ymdd {
                        width: 360px;
                        font-size: 24px;
                        line-height: 36px;
                        // line-height: 40px;
                        // overflow: hidden;
                        // text-overflow: ellipsis;
                        // white-space: nowrap;
                    }
                    .sides {
                        a {
                            background-color: #000;
                        }
                        .short {
                            background-color: #000;
                        }
                    }
                    .beautiful {
                        border-radius: 6px;
                        width: 160px;
                        height: 40px;
                        font-size: 14px;
                        margin-top: 32px;
                        color: #000;
                        border-color: #000;
                        background: -webkit-linear-gradient(left, #000, #000)
                            no-repeat;
                        background: linear-gradient(to right, #000, #000)
                            no-repeat;
                        background-size: 0% 100%;
                    }
                    .beautiful:hover {
                        background-size: 100% 100%;
                        color: #fabe00;
                    }
                }
            }
        }
    }
}
</style>
